import { closeAllTabs, setUser, signOutSuccess, useAppDispatch, useAppSelector } from '@/store'
import { logout } from '@/services/apiAuth'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function useAutoLogoutOnTabClose() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { signedIn } = useAppSelector(state => state.auth.session)
    const user = useAppSelector(state => state.auth.user)

    // auto logout on chrome exit
    useEffect(() => {
        if (!signedIn || !user.usersAutoLogoutOnTabClose) return;

        const handlePageHide = (event) => {
            const isReload = window?.performance?.navigation.type === 1 // 1: Reload

            if (!isReload) {
                logout().finally(()=> {
                    dispatch(signOutSuccess())
                    dispatch(closeAllTabs())
                    dispatch(setUser(null))
                    setTimeout(() => {
                        navigate('/login', { replace: true })
                    }, 500)
                })
            }
        }

        window.addEventListener('beforeunload', handlePageHide)

        return () => {
            window.removeEventListener('beforeunload', handlePageHide)
        }
    }, [signedIn, user])

}
